"use strict";
exports.__esModule = true;
exports.isRetriable = void 0;
var tslib_1 = require("tslib");
var errorinfo_1 = tslib_1.__importDefault(require("../types/errorinfo"));
var ConnectionErrors = {
    disconnected: errorinfo_1["default"].fromValues({
        statusCode: 400,
        code: 80003,
        message: 'Connection to server temporarily unavailable',
    }),
    suspended: errorinfo_1["default"].fromValues({
        statusCode: 400,
        code: 80002,
        message: 'Connection to server unavailable',
    }),
    failed: errorinfo_1["default"].fromValues({
        statusCode: 400,
        code: 80000,
        message: 'Connection failed or disconnected by server',
    }),
    closing: errorinfo_1["default"].fromValues({
        statusCode: 400,
        code: 80017,
        message: 'Connection closing',
    }),
    closed: errorinfo_1["default"].fromValues({
        statusCode: 400,
        code: 80017,
        message: 'Connection closed',
    }),
    unknownConnectionErr: errorinfo_1["default"].fromValues({
        statusCode: 500,
        code: 50002,
        message: 'Internal connection error',
    }),
    unknownChannelErr: errorinfo_1["default"].fromValues({
        statusCode: 500,
        code: 50001,
        message: 'Internal channel error',
    }),
};
function isRetriable(err) {
    if (!err.statusCode || !err.code || err.statusCode >= 500) {
        return true;
    }
    var retriable = false;
    Object.values(ConnectionErrors).forEach(function (connErr) {
        if (connErr.code && connErr.code == err.code) {
            retriable = true;
        }
    });
    return retriable;
}
exports.isRetriable = isRetriable;
exports["default"] = ConnectionErrors;
